import { useEffect, useState } from "react";

import { useGetLatestAnnouncementsQuery } from "@/services/api.announcements";

/**
 * Queue of unread + un-shown announcements, surfaced one popup at a time.
 * `closeActive` advances to the next pending announcement (or none).
 */
export function useAnnouncementQueue() {
  const { data } = useGetLatestAnnouncementsQuery();
  const [queue, setQueue] = useState<number[]>([]);
  const [activeAnnouncementId, setActiveAnnouncementId] = useState<
    number | null
  >(null);

  useEffect(() => {
    const announcements = data?.data?.announcementData;
    if (!announcements) return;

    const pending = announcements
      .filter((a) => !a.isRead && !a.isPopupShown)
      .map((a) => a.id);

    if (pending.length > 0) {
      setQueue(pending);
      setActiveAnnouncementId(pending[0]);
    }
  }, [data]);

  const closeActive = () => {
    const remaining = queue.slice(1);
    setQueue(remaining);
    setActiveAnnouncementId(remaining[0] ?? null);
  };

  return { activeAnnouncementId, closeActive };
}
